import { router } from 'react-query-kit'
import user from './user'
import map from './map';
import companyList from './companyList';

const userApis = router('users', user);
const mapApis = router('map', map);
const companyListApis = router('companyList', companyList);

export { userApis, mapApis, companyListApis };